export const NEWS_CATEGORIES = [
  'Αγώνες',
  'Ομάδα',
  'Ακαδημία',
  'Μεταγραφές',
  'Ανακοινώσεις',
  'Εθνικές Ομάδες',
  'Εκδηλώσεις',
  'Χορηγοί',
  'Κοινωνικές Δράσεις',
]

export const NEWS_STATUSES = [
  { value: 'draft', label: 'Πρόχειρο' },
  { value: 'published', label: 'Δημοσιευμένο' },
  { value: 'scheduled', label: 'Προγραμματισμένο' },
]

export const getNewsStatusLabel = (status, publishedAt) => {
  const effectiveStatus = status || 'published'

  if (effectiveStatus === 'scheduled' && publishedAt) {
    const publishDate = new Date(publishedAt)
    if (!Number.isNaN(publishDate.getTime()) && publishDate <= new Date()) {
      return 'Δημοσιευμένο (από πρόγραμμα)'
    }
  }

  return NEWS_STATUSES.find((item) => item.value === effectiveStatus)?.label || effectiveStatus
}
